module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"text1":"Disponible bajo petición."},"es":{"text1":"Disponible bajo petición."}}')
  delete Component.options._Ctor
}
